// extracted by mini-css-extract-plugin
export default {"button":"PlusButton_button__xBeJa"};